import { equals } from 'ramda';

/**
 * Checks if input value is `null`.
 *
 * @func isNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.1.0|v0.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {Boolean}
 * @see {@link RA.isNotNull|isNotNull}
 * @example
 *
 * RA.isNull(1); //=> false
 * RA.isNull(undefined); //=> false
 * RA.isNull(null); //=> true
 */
var isNull = /*#__PURE__*/equals(null);

export default isNull;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isNull.js
// module id = 199
// module chunks = 0